import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SubHeader from "../Subheader/Subheader";
import AccountingPlanningTabs from "./AccountingPlanning/AccountingPlanningTabs";
import Reports from "./Reports/Reports";
import Administration from "./Administration/Administration";
import "./FinancesTabs.css";

function FinancesTabs() {
  const tabs = [
    {
      id: "accounting-planning",
      label: "УЧЕТ И ПЛАНИРОВАНИЕ",
      path: "/finances/accounting-planning",
    },
    {
      id: "reports",
      label: "ОТЧЕТЫ",
      path: "/finances/reports",
    },
    {
      id: "administration",
      label: "АДМИНИСТРИРОВАНИЕ",
      path: "/finances/administration",
    },
  ];

  return (
    <div className="finances-tabs">
      <SubHeader tabs={tabs} />
      <div className="finances-tabs__content">
        <Routes>
          <Route
            path="accounting-planning/*"
            element={<AccountingPlanningTabs />}
          />
          <Route path="reports" element={<Reports />} />
          <Route path="administration" element={<Administration />} />
          <Route
            path="/"
            element={<Navigate to="accounting-planning" replace />}
          />
        </Routes>
      </div>
    </div>
  );
}

export default FinancesTabs;
